var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { alpha } from '@mui/material/styles';
import { fabClasses } from '@mui/material/Fab';
// ----------------------------------------------------------------------
var COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];
// ----------------------------------------------------------------------
export function fab(theme) {
    var lightMode = theme.palette.mode === 'light';
    var rootStyles = function (ownerState) {
        var _a;
        var defaultColor = ownerState.color === 'default';
        var inheritColor = ownerState.color === 'inherit';
        var circularVariant = ownerState.variant === 'circular';
        var extendedVariant = ownerState.variant === 'extended';
        var outlinedVariant = ownerState.variant === 'outlined';
        var outlinedExtendedVariant = ownerState.variant === 'outlinedExtended';
        var softVariant = ownerState.variant === 'soft';
        var softExtendedVariant = ownerState.variant === 'softExtended';
        var defaultStyle = __assign(__assign(__assign({ '&:hover, &:active': {
                boxShadow: 'none'
            } }, ((circularVariant || extendedVariant) && __assign(__assign({}, ((defaultColor || inheritColor) && {
            boxShadow: theme.customShadows.z8
        })), (inheritColor && {
            backgroundColor: theme.palette.text.primary,
            color: lightMode ? theme.palette.common.white : theme.palette.grey[800],
            '&:hover': {
                backgroundColor: lightMode ? theme.palette.grey[700] : theme.palette.grey[400]
            }
        })))), ((outlinedVariant || outlinedExtendedVariant) && __assign(__assign(__assign({ boxShadow: 'none', backgroundColor: 'transparent' }, ((defaultColor || inheritColor) && {
            border: "solid 1px ".concat(alpha(theme.palette.grey[500], 0.32))
        })), (defaultColor && __assign({}, (!lightMode && {
            color: theme.palette.text.secondary
        })))), { '&:hover': {
                borderColor: 'currentColor',
                boxShadow: '0 0 0 0.5px currentColor',
                backgroundColor: theme.palette.action.hover
            } }))), ((softVariant || softExtendedVariant) && __assign(__assign({ boxShadow: 'none' }, (defaultColor && {
            color: theme.palette.grey[800],
            backgroundColor: theme.palette.grey[300],
            '&:hover': {
                backgroundColor: theme.palette.grey[400]
            }
        })), (inheritColor && {
            backgroundColor: alpha(theme.palette.grey[500], 0.08),
            '&:hover': {
                backgroundColor: alpha(theme.palette.grey[500], 0.24)
            }
        }))));
        var colorStyle = COLORS.map(function (color) { return (__assign({}, (ownerState.color === color && __assign(__assign(__assign({}, ((circularVariant || extendedVariant) && {
            boxShadow: theme.customShadows[color],
            '&:hover': {
                backgroundColor: theme.palette[color].dark
            }
        })), ((outlinedVariant || outlinedExtendedVariant) && {
            color: theme.palette[color].main,
            border: "solid 1px ".concat(alpha(theme.palette[color].main, 0.48)),
            '&:hover': {
                backgroundColor: alpha(theme.palette[color].main, 0.08)
            }
        })), ((softVariant || softExtendedVariant) && {
            color: theme.palette[color][lightMode ? 'dark' : 'light'],
            backgroundColor: alpha(theme.palette[color].main, 0.16),
            '&:hover': {
                backgroundColor: alpha(theme.palette[color].main, 0.32)
            }
        }))))); });
        var disabledState = (_a = {},
            _a["&.".concat(fabClasses.disabled)] = __assign({}, ((outlinedVariant || outlinedExtendedVariant) && {
                backgroundColor: 'transparent',
                border: "solid 1px ".concat(theme.palette.action.disabledBackground)
            })),
            _a);
        var size = __assign({}, ((extendedVariant || outlinedExtendedVariant || softExtendedVariant) && __assign(__assign(__assign({ width: 'auto', '& svg': {
                marginRight: theme.spacing(1)
            } }, (ownerState.size === 'small' && {
            height: 34,
            minHeight: 34,
            borderRadius: 17,
            padding: theme.spacing(0, 1)
        })), (ownerState.size === 'medium' && {
            height: 40,
            minHeight: 40,
            borderRadius: 20,
            padding: theme.spacing(0, 2)
        })), (ownerState.size === 'large' && {
            height: 48,
            minHeight: 48,
            borderRadius: 24,
            padding: theme.spacing(0, 2)
        }))));
        return __spreadArray(__spreadArray([defaultStyle], __read(colorStyle), false), [disabledState, size], false);
    };
    return {
        MuiFab: {
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return rootStyles(ownerState);
                }
            }
        }
    };
}
